(function(){
  var PROFILES={
    classic:{
      '38':{label:'S/38',waist:['37','38'],thigh:['30','31'],inseam:['73','75'],hem:['16.5','17.5']},
      '40':{label:'M/40',waist:['39','40'],thigh:['31','32'],inseam:['73','75'],hem:['17','18']},
      '42':{label:'L/42',waist:['41','42'],thigh:['32','33'],inseam:['73','75'],hem:['17.5','18.5']},
      '44':{label:'XL/44',waist:['43','44'],thigh:['33','34'],inseam:['73','75'],hem:['18','19']}
    },
    sand:{
      '38':{label:'S/38',waist:['37','38'],thigh:['28.5','29.5'],inseam:['74','76'],hem:['15.5','16.5']},
      '40':{label:'M/40',waist:['39','40'],thigh:['29.5','30.5'],inseam:['74','76'],hem:['16','17']},
      '42':{label:'L/42',waist:['41','42'],thigh:['30.5','31.5'],inseam:['74','76'],hem:['16.5','17.5']},
      '44':{label:'XL/44',waist:['43','44'],thigh:['31.5','32.5'],inseam:['74','76'],hem:['17','18']}
    }
  };

  function cmRange(a){
    return a.map(function(v){return String(v).replace('.',',')}).join('–');
  }
  function inRange(a){
    return a.map(function(v){
      var n=parseFloat(v);
      return (n/2.54).toFixed(1).replace('.',',');
    }).join('–');
  }

  function init(root){
    if(!root||root.dataset.moraySizeGuideInit==='1')return;
    root.dataset.moraySizeGuideInit='1';

    var drawer=root.querySelector('[data-moray-pants-size-guide]');
    var opener=root.querySelector('[data-moray-size-guide-open]');
    if(!drawer||!opener)return;

    var profile=drawer.getAttribute('data-pants-guide-profile')||'classic';
    var DATA=PROFILES[profile]||PROFILES.classic;
    var current='38';

    var tabs=drawer.querySelectorAll('[data-size-guide-size]');
    var waist=drawer.querySelector('[data-size-guide-waist]');
    var waistIn=drawer.querySelector('[data-size-guide-waist-in]');
    var thigh=drawer.querySelector('[data-size-guide-thigh]');
    var thighIn=drawer.querySelector('[data-size-guide-thigh-in]');
    var inseam=drawer.querySelector('[data-size-guide-inseam]');
    var inseamIn=drawer.querySelector('[data-size-guide-inseam-in]');
    var hem=drawer.querySelector('[data-size-guide-hem]');
    var hemIn=drawer.querySelector('[data-size-guide-hem-in]');
    var choose=drawer.querySelector('[data-moray-size-guide-choose]');

    function matchingSizeButton(){
      return Array.prototype.find.call(root.querySelectorAll('[data-pdp-size-row] [data-pdp-value]'),function(btn){
        var v=(btn.getAttribute('data-pdp-value')||'').trim().toLowerCase();
        var label=(DATA[current]&&DATA[current].label||'').toLowerCase();
        return v===label||v===current.toLowerCase()||v.endsWith('/'+current);
      });
    }

    function paint(size){
      if(!DATA[size])return;
      current=size;
      var d=DATA[size];

      tabs.forEach(function(btn){
        var on=btn.getAttribute('data-size-guide-size')===size;
        btn.classList.toggle('is-active',on);
        btn.setAttribute('aria-selected',String(on));
      });

      waist.textContent=cmRange(d.waist);
      waistIn.textContent=inRange(d.waist);
      thigh.textContent=cmRange(d.thigh);
      thighIn.textContent=inRange(d.thigh);
      inseam.textContent=cmRange(d.inseam);
      inseamIn.textContent=inRange(d.inseam);
      hem.textContent=cmRange(d.hem);
      hemIn.textContent=inRange(d.hem);

      choose.textContent='Añadir '+d.label+' a la cesta';

      var sizeBtn=matchingSizeButton();
      var unavailable=sizeBtn&&sizeBtn.classList.contains('is-off');
      choose.disabled=!!unavailable;
      if(unavailable) choose.textContent=d.label+' · Agotado';
    }

    function syncFromPdp(){
      var active=root.querySelector('[data-pdp-size-row] [data-pdp-value].is-active');
      if(!active)return;
      var value=(active.getAttribute('data-pdp-value')||'');
      var match=value.match(/(38|40|42|44)$/);
      if(match&&DATA[match[1]])current=match[1];
    }

    function open(){
      syncFromPdp();
      drawer.hidden=false;
      requestAnimationFrame(function(){drawer.classList.add('is-open')});
      document.documentElement.classList.add('moray-size-guide-open');
      paint(current);
      var active=drawer.querySelector('[data-size-guide-size].is-active');
      if(active)active.focus();
    }

    function close(returnFocus){
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('moray-size-guide-open');
      setTimeout(function(){if(!drawer.classList.contains('is-open'))drawer.hidden=true},340);
      if(returnFocus!==false)opener.focus();
    }

    opener.addEventListener('click',open);

    drawer.addEventListener('click',function(e){
      var closeBtn=e.target.closest('[data-moray-size-guide-close]');
      if(closeBtn){close();return}

      var tab=e.target.closest('[data-size-guide-size]');
      if(tab){paint(tab.getAttribute('data-size-guide-size'));return}

      if(e.target.closest('[data-moray-size-guide-choose]')){
        var sizeButton=matchingSizeButton();
        if(!sizeButton||sizeButton.classList.contains('is-off'))return;
        sizeButton.click();
        var add=root.querySelector('[data-pdp-add]');
        close(false);
        if(add&&!add.disabled){setTimeout(function(){add.click()},0)}
      }
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&!drawer.hidden)close();
    });
  }

  function initAll(){document.querySelectorAll('[data-pdp]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll,{once:true});else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();